<template>
    <activix-badge bg-color-class="bg-blue-600" text-color-class="text-blue-100">
        <span data-testid="badge-label" class="text-xs font-semibold uppercase">
            {{ t('smsCommunication.group') }}
        </span>
    </activix-badge>
</template>

<script setup lang="ts">
    import ActivixBadge from '@/components/elements/ActivixBadge.vue';
    import { useI18n } from '@/hooks/useI18n.ts';

    const { t } = useI18n();
</script>
